var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { SubmitButton } from '@/components/functional/Form/SubmitButton';
import { UserBoxList } from '@/components/modules/List/UserBoxList';
import { Button } from '@/components/ui/Button/Button';
import { ModalFooterAction } from '@/components/ui/Modal/Modal';
import { ModalWithTitle } from '@/components/ui/Modal/ModalWithTitle';
import { Text } from '@/components/ui/Typography/Body/Text';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { professionalUnitPath } from '@/utils/router/links';
const commentText = '開示後は非開示に戻せません';
export const ViewRequestModal = (props) => {
    const { className = '', hideModal: propHideModal, isShow, onClickSubmit: propOnClickSubmit, selectedIds, selectedUsers, } = props;
    const unmountRef = useUnmountRef();
    // UserBoxList表示用に object 変更
    const userBoxListItems = useMemo(() => selectedUsers.map((user) => {
        const { companyName, urlCode } = user, other = __rest(user, ["companyName", "urlCode"]);
        return Object.assign({ extraTexts: companyName
                ? [
                    {
                        link: urlCode ? professionalUnitPath(urlCode) : '',
                        text: companyName,
                    },
                ]
                : [] }, other);
    }), [selectedUsers]);
    // ローディング制御
    const { callbackPromiseEvent, doing: loading } = usePromiseDoingCallback({
        finallyCallbackFunc: propHideModal,
        promiseEvent: propOnClickSubmit,
        unmountRef,
    });
    // 非同期処理中はモーダル閉じれないよう制御
    const hideModal = useCallback(() => {
        if (!loading) {
            propHideModal();
        }
    }, [loading, propHideModal]);
    const onClickSubmit = useCallback(() => {
        callbackPromiseEvent(selectedIds);
    }, [callbackPromiseEvent, selectedIds]);
    return (_jsxs(ModalWithTitle, Object.assign({ className: className, headText: '企業名を開示する', hideModal: hideModal, isShow: isShow }, { children: [_jsx(Head, Object.assign({ className: 'text-center', size: 'xs' }, { children: "\u4E0B\u8A18\u306E\u30C1\u30FC\u30E0\u306B\u4F01\u696D\u540D\u3092\u958B\u793A\u3057\u307E\u3059\u304B\uFF1F" })), _jsx(Text, Object.assign({ className: clsx('text-center', 'mt-8'), color: 'base', size: 'sm' }, { children: _jsx("span", Object.assign({ className: 'inline-block text-left' }, { children: "\u90E8\u9580\u540D\u3001\u6C0F\u540D\u3001\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u60C5\u5831\u306F\u958B\u793A\u3055\u308C\u307E\u305B\u3093" })) })), _jsx(UserBoxList, { className: 'mt-28', items: userBoxListItems }), _jsxs(ModalFooterAction, Object.assign({ className: 'items-start md:mx-40' }, { children: [_jsx(Button, Object.assign({ className: 'flex-1', color: 'gray', disabled: loading, onClick: hideModal, size: 'md' }, { children: "\u30AD\u30E3\u30F3\u30BB\u30EB" })), _jsxs("div", Object.assign({ className: 'flex-1' }, { children: [_jsx(SubmitButton, Object.assign({ className: clsx('!w-full md:w-[200px]'), color: 'orange', loading: loading, onClick: onClickSubmit, size: 'md' }, { children: "\u958B\u793A\u3059\u308B" })), _jsx(Text, Object.assign({ className: clsx('mt-8', 'text-center hidden md:block'), color: 'error', size: 'sm' }, { children: commentText }))] }))] })), _jsx(Text, Object.assign({ className: clsx('mt-20', 'text-center block md:hidden'), color: 'error', size: 'sm' }, { children: commentText }))] })));
};
